var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98759 12.9341C8.53112 17.8306 12.1588 21.4352 16.9957 23.9772C18.0589 22.9146 19.1639 21.8728 20.2064 20.7476C20.9778 19.9142 21.77 19.7266 22.8958 19.9975C24.5637 20.4142 26.2942 20.6434 28.0037 20.8101C29.3798 20.956 29.9635 21.4352 29.9844 22.7896C30.0052 24.5606 30.0052 26.3317 29.9844 28.1028C29.9635 29.3946 29.3381 29.978 28.0454 29.9989C14.744 30.1239 2.50587 19.7475 0.421007 6.55819C0.191672 5.01631 0.0874286 3.4536 0.00403403 1.91172C-0.0585119 0.682385 0.608644 0.0364633 1.83871 0.0156271C3.67339 -0.00520904 5.50807 -0.00520904 7.3636 0.0156271C8.53112 0.0364633 9.05234 0.661549 9.17743 1.82837C9.40677 3.68279 9.65695 5.53721 10.0531 7.34996C10.2407 8.24592 10.1365 8.91267 9.51101 9.51692C8.32264 10.6629 7.15511 11.7881 5.98759 12.9341Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a14a18b3d296e2341ed8b24242a315b6.svg";
export { ForwardRef as ReactComponent };